module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-notconnected"
  }, [_c('div', {
    staticClass: "kiwi-notconnected-bigicon"
  }, [(!_vm.shouldShowLoading) ? _c('i', {
    staticClass: "fa fa-plug",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.reconnect
    }
  }) : _c('i', {
    staticClass: "fa fa-refresh fa-spin kiwi-notconnected-bigicon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (!_vm.shouldShowLoading) ? _c('div', {
    staticClass: "kiwi-notconnected-caption"
  }, [(_vm.isChannel()) ? [_c('span', {
    on: {
      "click": _vm.reconnect
    }
  }, [_vm._v(_vm._s(_vm.$t('reconnect_channel', {
    channel: _vm.buffer.name
  })))])] : (_vm.isServer()) ? [_c('span', {
    on: {
      "click": _vm.reconnect
    }
  }, [_vm._v(_vm._s(_vm.$t('reconnect_network', {
    network: _vm.buffer.getNetwork().name
  })))])] : (_vm.isQuery()) ? [_c('span', {
    on: {
      "click": _vm.reconnect
    }
  }, [_vm._v(_vm._s(_vm.$t('reconnect_query', {
    user: _vm.buffer.name
  })))])] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "kiwi-notconnected-networksettings u-link",
    on: {
      "click": _vm.showNetworkSettings
    }
  }, [_vm._v(_vm._s(_vm.$t('reconnect_settings')))])], 2) : _c('div', {
    staticClass: "kiwi-notconnected-caption"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('connecting')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ba15441!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotConnected.vue
// module id = 479
// module chunks = 2